
<a v-if="linkedViewPath" :href="linkedViewPath" :class="disabled ? 'disabled-link' : 'btn-link'">
  <slot></slot>
</a>
<div v-else>
  <slot></slot>
</div>
